import React, { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { StatusMeter, TeamLogo } from "../bondhouse/FixtureStatus";
import {
  fixtureMatchLabel,
  fixtureStatusPayload,
  formatFixtureKickoff,
  formatKickoffCountdown,
  isKickoffSoon,
} from "../../utils/fixturesDeskHelpers";

const FixtureKickoffSoonBanner = ({ fixture }) => {
  const [, tick] = useState(0);

  useEffect(() => {
    if (!fixture) return undefined;
    const id = window.setInterval(() => tick((n) => n + 1), 1000);
    return () => window.clearInterval(id);
  }, [fixture]);

  if (!fixture) {
    return (
      <div className="fd-desk-kickoff-soon fd-desk-kickoff-soon-empty" role="status">
        <CalendarClock size={13} aria-hidden />
        <span>No fixtures kicking off soon</span>
      </div>
    );
  }

  const home = fixture.homeTeam || {};
  const away = fixture.awayTeam || {};
  const match = fixtureMatchLabel(fixture);
  const countdown = formatKickoffCountdown(fixture);
  const soon = isKickoffSoon(fixture);
  const kickoffTitle = formatFixtureKickoff(fixture);

  return (
    <div className="fd-desk-kickoff-soon" role="status" title={kickoffTitle}>
      <CalendarClock size={13} aria-hidden />
      <span className="fd-desk-kickoff-soon-label">
        {soon ? "Kicking off soon" : "Next kickoff"}
      </span>
      <span className="fd-desk-kickoff-soon-sep" aria-hidden>
        ·
      </span>
      <div className="fd-desk-kickoff-soon-teams" aria-label={match}>
        <span className="fd-desk-kickoff-soon-side">
          <TeamLogo team={home} size="sm" />
          <span className="fd-desk-kickoff-soon-name" title={home.name}>
            {home.name || "Home"}
          </span>
        </span>
        <div className="fd-desk-kickoff-soon-status">
          <StatusMeter fixture={fixtureStatusPayload(fixture)} variant="compact" />
        </div>
        <span className="fd-desk-kickoff-soon-side fd-desk-kickoff-soon-side-away">
          <span className="fd-desk-kickoff-soon-name" title={away.name}>
            {away.name || "Away"}
          </span>
          <TeamLogo team={away} size="sm" />
        </span>
      </div>
      {countdown ? (
        <>
          <span className="fd-desk-kickoff-soon-sep" aria-hidden>
            ·
          </span>
          <span className="fd-desk-kickoff-soon-countdown tabular-nums">
            {countdown.text}
          </span>
        </>
      ) : null}
    </div>
  );
};

export default FixtureKickoffSoonBanner;
